import { AxiosInstance, InternalAxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { authToken } from "@/account/composables/user-cookies";

export const oAuthInterceptor = (config: InternalAxiosRequestConfig) => {
    if (authToken.value) {
        config.headers ??= {} as AxiosRequestHeaders;
        config.headers["Authorization"] = `Oauth ${authToken.value}`;
    }

    return config;
};

export const addOAuthInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.request.use(oAuthInterceptor, null, { synchronous: true });
};
